import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Alert from 'react-bootstrap/Alert';
import FormControl from 'react-bootstrap/FormControl';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Questionnaire.css';
import { Form, Col } from 'react-bootstrap';
import SecurityPage from './components/SecurityPage';
import SpinnerPage from './components/SpinnerPage';
import SurveyCondition from './components/SurveyCondition';
import SurveyEpworthItem from './components/SurveyEpworthItem'
import SurveyFrequencyItem from './components/SurveyFrequencyItem'
import { withRouter} from 'react-router-dom';

// define constants
const QUESTION_ONE = "Have you been diagnosed or treated for any of the following conditions?";
const QUESTION_TWO = "Have you been diagnosed or treated for any of the following conditions? Or are you using any of the following?";
const QUESTION_THREE = "How likely are you to doze off or fall asleep in the following situations, in contrast to just feeling tired?";
const QUESTION_FOUR = "How frequently do you experience the following?";

// because we are having to use "withRouter", we export the class at the bottom of the page
class Questionnaire extends Component {
    constructor() {
        super();

        // initialize state variables
        this.state = {
            page: -1,
            showSpinner: false,
            errorMsg: null,
            urlType: null,
            phoneDigits: null,
            pageQuestion: "Security Verification",
            pageButtonLabel: "Next",
            riskCategorization: "",
            severityCategorization: "",
            patientBirthMonth: null,
            patientBirthDay: null,
            patientBirthYear: null,
            patientGender: null,
            patientWeight: null,
            patientHeightFeet: -1,
            patientHeightInches: 0,
            patientNeckSize: 16,
            hasHighBloodPressure: null,
            hasHeartDisease: null,
            hasDiabetes: null,
            hasHadStroke: null,
            hasDepression: null,
            hasSleepApnea: null,
            hasLungDisease: null,
            hasInsomnia: null,
            hasNarcolepsy: null,
            utilizesSupplementalNasalOxygen: null,
            hasRestlessLegSyndrome: null,
            experiencesMorningHeadache: null,
            takesSleepingMedication: null,
            takesPainMedication: null,
            sittingReading: null,
            watchingTelevision: null,
            sittingReadingInPublic: null,
            passengerInCar: null,
            restingDuringAfternoon: null,
            sittingAndTalking: null,
            sittingAfterLunch: null,
            sittingPassengerInCarStoppedInTraffic: null,
            howOftenSnoredInPastMonth: null,
            wakeUpChokingOrGasping: null,
            howOftenSomeoneElseTellsChokingOrGasping: null,
            difficultyKeepingLegsStillAtNight: null
        };

        // get references to child components
        this.SecurityPage = React.createRef();

        // bind functions for accessing state
        this.btnBackClick = this.btnBackClick.bind(this);
        this.btnNextClick = this.btnNextClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleFormControlChange = this.handleFormControlChange.bind(this);
    }

    componentDidMount() {
        // get referenceID from querystring
        let refID = this.getQueryStringArg("refID");

        // show spinner, while we retrieve info
        this.setState({ showSpinner: true });
        
        // only proceed if we have a reference guid
        if (refID) {
            // get patient challenge information from reference guid
            var getURLReferenceInfo = () => {
                return fetch(this.props.baseAPIURL + "/SleepMed.Service.Main/hst/GetURLReferenceInfo", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(refID)
                })
                .then((response) => response.json())
                .then((json) => {
                    // attempt to set branding, based on urltype
                    if (json.URLType === "Report") {
                        // this is a report, so change button from "next" to "show report"
                        this.setState({ pageButtonLabel: "Show My Results"});

                        // set the page title
                        document.title = "Livosa Report"

                        // set brand to livosa
                        this.props.onSetCurrentBrand("livosa");
                    }
                    else {
                        // if not a "report" type, we'll default to watermark
                        // set url type
                        this.setState({ urlType: "Survey" });

                        // set page title
                        document.title = "MTP Questionnaire"

                        // set brand to watermark
                        this.props.onSetCurrentBrand("wm");
                    }

                    // see if we got security verification data back
                    if (json.PhoneDigits && json.PhoneDigits.toLowerCase() !== "error") {
                        // reference GUID is valid, show phone digits as challenge
                        this.setState({ phoneDigits: json.PhoneDigits});

                        // hide spinner
                        this.setState({ showSpinner: false });
                    }
                    else {
                        // we don't have valid security information, so we're dealing with an error case
                        // will also need to adapt CustomErrorPage.js so it doesn't always say to call support?
                        if (json.ErrorReason) {
                            // we have an error reason
                            switch (json.ErrorReason.toLowerCase()) {
                                case "attempts exceeded":
                                    this.props.onSetCustomErrorMessage("Security access attempts exceeded.");

                                    // we have to use react-router's history push or the parent app
                                    // gets reset and loses all state, so we can't do a plain window navigation here
                                    //window.location.replace("/error");
                                    this.props.history.push("/error");                                    
                                    break;
                                case "expired":
                                    this.props.onSetCustomErrorMessage("Your survey link has expired.");
                                    this.props.history.push("/expired");  
                                    break;
                                case "used":
                                    this.props.onSetCustomErrorMessage("Your survey has been completed.  Thank you!");
                                    this.props.history.push("/complete");  
                                    break;
                                default:
                                    // unkown error, this is invalid, show 404
                                    window.location.replace("/NOTFOUND");
                                    break;
                            }
                        }
                        else {
                            // we have no error reason
                            // no data returned, this is invalid, show 404
                            window.location.replace("/NOTFOUND");
                        }
                    }
                })
                .catch((error) => {
                    // TODO: what do we do on error when calling API?
                    // for now, log to console
                    console.log(error);

                    // hide spinner
                    this.setState({ showSpinner: false });
                });
            };

            getURLReferenceInfo();
        }
        else {
            // no reference GUID provided, display 404
            window.location.replace("/NOTFOUND");
        }
    }

    // gets named parameter value from query string
    getQueryStringArg(param) {
        // convert search string to lowercase to prevent case-sensitivity issues
        let search = window.location.search.toLowerCase();        
        let params = new URLSearchParams(search);

        return params.get(param.toLowerCase());
    }

    // fired when user clicks back button
    btnBackClick() {
        // move page back by one
        var nextPage = this.state.page - 1;
        this.setState({ page: nextPage });
        this.setState({ pageButtonLabel: "Next"});  // next buton could say "Finish", so switch it back

        // change page title question to match page to which we're navigating
        switch (nextPage) {
            case 0:
                this.setState({ pageQuestion: "Physical Information" });
                break;
            case 1:
                this.setState({ pageQuestion: QUESTION_ONE });
                break;
            case 2:
                this.setState({ pageQuestion: QUESTION_TWO });
                break;
            case 3:
            case 4:
                this.setState({ pageQuestion: QUESTION_THREE });
                break;
            default:
                break;
        }
    }

    // fired when user clicks next button
    btnNextClick() {
        // advance UI to next page
        var nextPage = this.state.page + 1;

        // to prevent screen flicker if user fails security questions
        // move page within fetch block on success, instead of here
        if (nextPage !== 0) {
            this.setState({ page: nextPage });
        }

        switch (nextPage) {
            case 0:
                // validate birth year and phone digits
                var currentSecurityPage = this.SecurityPage.current;
                if (currentSecurityPage.state.patientBirthMonth === -1 || currentSecurityPage.state.patientBirthDay === -1 ||
                    !currentSecurityPage.state.patientBirthYear || !currentSecurityPage.state.phoneDigits) {
                    // user hasn't filled out everything
                    this.showValidationError(nextPage, "*All fields are required");
                }
                else {
                    // validate birth year is between given range
                    let iBirthYear = parseInt(currentSecurityPage.state.patientBirthYear); 
                    if (iBirthYear > 1900 && iBirthYear < 2099) {

                        // validate phone digits are numeric
                        if (isNaN(currentSecurityPage.state.phoneDigits)) {
                            // phone digits aren't numeric
                            this.showValidationError(nextPage, "*Please enter valid a phone number");
                        }
                        else {
                            // form data is good, post it to API see if it's correct
                            var securityInfo = {
                                TempURLGUID: this.getQueryStringArg("refID"),
                                PatientDOB: currentSecurityPage.state.patientBirthMonth + '/' + currentSecurityPage.state.patientBirthDay + '/' + currentSecurityPage.state.patientBirthYear,
                                PhoneDigits: currentSecurityPage.state.phoneDigits
                            }

                            // show spinner while we verify answers
                            this.setState({ showSpinner: true });

                            // verify security data matches what we have in the database
                            var verifyPatientSecurityInfo = () => {
                                return fetch(this.props.baseAPIURL + "/SleepMed.Service.Main/hst/VerifyPatientSecurityInfo", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify(securityInfo)
                                })
                                .then((response) => response.json())
                                .then((json) => {
                                    // determine if we're dealing with a questionnaire or report URL
                                    switch (json.URLType) {
                                        case "Survey":
                                            // all is valid, move to next page
                                            this.setState({ page: nextPage });
                                            this.setState({ pageQuestion: "Physical Information" });
                                            this.hideValidationError()

                                            // save info for use in final upload
                                            this.setState({ patientBirthMonth: currentSecurityPage.state.patientBirthMonth });
                                            this.setState({ patientBirthDay: currentSecurityPage.state.patientBirthDay });
                                            this.setState({ patientBirthYear: currentSecurityPage.state.patientBirthYear });

                                            // hide spinner
                                            this.setState({ showSpinner: false });
                                            break;
                                        case "Report":
                                            // all is valid, set security info on parent app to pass to report component
                                            this.props.onSetSecurityInfo(JSON.stringify(securityInfo));

                                            // we have to use react-router's history push or the parent app
                                            // gets reset and loses all state, so we can't do a plain window navigation here
                                            //window.location.replace("/report");
                                            this.props.history.push("/report");
                                            break;
                                        case "invalid":
                                            if (json.ErrorReason && json.ErrorReason.toLowerCase() === 'attempts exceeded') {
                                                this.props.onSetCustomErrorMessage("Security access attempts exceeded.");

                                                // we have to use react-router's history push or the parent app
                                                // gets reset and loses all state, so we can't do a plain window navigation here
                                                //window.location.replace("/error");
                                                this.props.history.push("/error");
                                            }
                                            else {
                                                // security info was wrong
                                                this.showValidationError(nextPage, "The information you entered does not match our records. Please try again.");

                                                // hide spinner
                                                this.setState({ showSpinner: false });
                                            }
                                            break;
                                        default:
                                            // security info or URL invalid
                                            // for now, display 404
                                            window.location.replace("/NOTFOUND");
                                            break;
                                    }
                                })
                                .catch((error) => {
                                    // TODO: Again, what do we do if API call fails?
                                    console.log(error);
                                });
                            };
                    
                            verifyPatientSecurityInfo();
                        }
                    }
                    else {
                        // birth year isn't within range
                        this.showValidationError(nextPage, "*Please enter a valid birth year");
                    }
                }
                break;
            case 1:
                // validate user has filled out all fields
                if (!this.state.patientGender || !this.state.patientWeight || this.state.patientHeightFeet === -1 || !this.state.patientNeckSize) {
                    this.showValidationError(nextPage, "*All fields are required");
                }
                else {
                    // make sure weight is numeric
                    if (isNaN(this.state.patientWeight)) {
                        this.showValidationError(nextPage, "*Please enter a valid weight");
                    }
                    else {
                        this.setState({ pageQuestion: QUESTION_ONE });
                        this.hideValidationError()
                    }
                }
                break;
            case 2:
                // validate user has answered all questions
                if (this.state.hasHighBloodPressure === null || this.state.hasHeartDisease === null || this.state.hasDiabetes === null ||
                    this.state.hasHadStroke === null || this.state.hasDepression === null || this.state.hasSleepApnea === null ||
                    this.state.hasLungDisease === null) {
                    this.showValidationError(nextPage, "*Please answer all questions");
                }
                else {
                    this.setState({ pageQuestion: QUESTION_TWO });
                    this.hideValidationError()
                }
                break;
            case 3:
                // validate user has answered all questions
                if (this.state.utilizesSupplementalNasalOxygen === null || this.state.hasInsomnia === null ||
                    this.state.hasRestlessLegSyndrome === null || this.state.hasNarcolepsy === null ||
                    this.state.experiencesMorningHeadache === null || this.state.takesSleepingMedication === null ||
                    this.state.takesPainMedication === null) {
                    this.showValidationError(nextPage, "*Please answer all questions");
                }
                else {
                    this.setState({ pageQuestion: QUESTION_THREE });
                    this.hideValidationError()
                }
                break;
            case 4:
                // validate user has answered all questions
                if (this.state.sittingReading === null || this.state.watchingTelevision === null ||
                    this.state.sittingReadingInPublic === null || this.state.passengerInCar === null) {
                    this.showValidationError(nextPage, "*Please answer all questions");
                }
                else {                    
                    this.hideValidationError()
                }
                break;            
            case 5:
                // validate user has answered all questions
                if (this.state.restingDuringAfternoon === null || this.state.sittingAndTalking === null ||
                    this.state.sittingAfterLunch === null || this.state.sittingPassengerInCarStoppedInTraffic === null) {
                    this.showValidationError(nextPage, "*Please answer all questions");
                }
                else {
                    this.setState({ pageQuestion: QUESTION_FOUR });
                    this.setState({ pageButtonLabel: "Finish"});
                    this.hideValidationError()
                }
                break;
            default:
                // validate user has answered all questions
                if (this.state.howOftenSnoredInPastMonth === null || this.state.wakeUpChokingOrGasping === null ||
                    this.state.howOftenSomeoneElseTellsChokingOrGasping === null || this.state.difficultyKeepingLegsStillAtNight === null) {
                    this.showValidationError(nextPage, "*Please answer all questions");
                }
                else {
                    // user is clicking "Finish"
                    // survey is complete, package answers into JSON
                    this.hideValidationError()
                    
                    this.setState({ pageQuestion: "Watermark Medical" });

                    var patientInformation = {
                        gender: this.state.patientGender,
                        age: this.getAge(this.state.patientBirthMonth + "/" + this.state.patientBirthDay + "/" + this.state.patientBirthYear),
                        weightPounds: parseInt(this.state.patientWeight),
                        heightFeet: parseInt(this.state.patientHeightFeet),
                        heightInches: parseInt(this.state.patientHeightInches),
                        neckCircumferenceInches: parseInt(this.state.patientNeckSize)
                    }

                    var medicalConditions = {
                        hasHighBloodPressure: this.state.hasHighBloodPressure,
                        hasHeartDisease: this.state.hasHeartDisease,
                        hasDiabetes: this.state.hasDiabetes,
                        hasHadStroke: this.state.hasHadStroke,
                        hasDepression: this.state.hasDepression,
                        hasSleepApnea: this.state.hasSleepApnea,
                        hasLungDisease: this.state.hasLungDisease,
                        hasInsomnia: this.state.hasInsomnia,
                        hasNarcolepsy: this.state.hasNarcolepsy,
                        utilizesSupplementalNasalOxygen: this.state.utilizesSupplementalNasalOxygen,
                        hasRestlessLegSyndrome: this.state.hasRestlessLegSyndrome,
                        experiencesMorningHeadache: this.state.experiencesMorningHeadache,
                        takesSleepingMedication: this.state.takesSleepingMedication,
                        takesPainMedication: this.state.takesPainMedication
                    };

                    var epworth = {
                        sittingReading: this.state.sittingReading,
                        watchingTelevision: this.state.watchingTelevision,
                        sittingReadingInPublic: this.state.sittingReadingInPublic,
                        passengerInCar: this.state.passengerInCar,
                        restingDuringAfternoon: this.state.restingDuringAfternoon,
                        sittingAndTalking: this.state.sittingAndTalking,
                        sittingAfterLunch: this.state.sittingAfterLunch,
                        sittingPassengerInCarStoppedInTraffic: this.state.sittingPassengerInCarStoppedInTraffic
                    };

                    var snore = {
                        howOftenSnoredInPastMonth: this.state.howOftenSnoredInPastMonth,
                        wakeUpChokingOrGasping: this.state.wakeUpChokingOrGasping,
                        howOftenSomeoneElseTellsChokingOrGasping: this.state.howOftenSomeoneElseTellsChokingOrGasping,
                        difficultyKeepingLegsStillAtNight: this.state.difficultyKeepingLegsStillAtNight
                    };

                    var surveyInput = {
                        DEBUG: true,
                        patientInformation: patientInformation,
                        medicalConditions: medicalConditions,
                        epworth: epworth,
                        snore: snore
                    }
                    
                    // show spinner, while we retrieve info
                    this.setState({ showSpinner: true });

                    // note: when CORS isn't enabled on server, proxy must be used in package.json
                    // (e.g. "proxy": "https://api.dev.watermarkmedical.com" and fetch shortened to just "/questionnaire")
                    // this is gallagher's ugly url: https://mdkubbjbu1.execute-api.us-east-1.amazonaws.com/default/questionnaire
                    // but it doesn't seem to work with CORS, must use nicer URL: https://api.dev.watermarkmedical.com/questionnaire
                    //const API_REPORT = "https://api.dev.watermarkmedical.com/questionnaire";
                    var getResultsFromAPI = () => {
                        return fetch(this.props.questionAPIURL, {
                                    method: "POST",
                                    headers: {
                                        "x-api-key": this.props.questionAPIToken
                                        //"x-api-key": "Z1QVYrUP4v4d8j5MdH31M6oj4Bqlh9Ik9pySLJYa"
                                        //"x-api-key": "B0mUcS0JzhSjv1KOBMz140LAoPc3Itb8qKGl1WY7"//,
                                        //"origin": "https://dev.d3mo1yv8gyi3cl.amplifyapp.com/"        
                                    },
                                    body: JSON.stringify(surveyInput)
                                })
                            .then((response) => response.json())
                            .then((json) => {
                                //alert(JSON.stringify(json.results));
                                //this.setState({ riskCategorization: json.results.osaRiskCategorization});
                                //this.setState({ severityCategorization: json.results.osaSeverityCategorization});
                                var surveyResults = json.results;

                                var surveyInfo = {
                                    TempURLGUID: this.getQueryStringArg("refID"),
                                    MTPOrderNumber: null,
                                    NeckCircumference: surveyInput.patientInformation.neckCircumferenceInches,
                                    HeightFeet: surveyInput.patientInformation.heightFeet,
                                    HeightInches: surveyInput.patientInformation.heightInches,
                                    Weight: surveyInput.patientInformation.weightPounds,
                                    HighBP: surveyInput.medicalConditions.hasHighBloodPressure,
                                    HeartDisease: surveyInput.medicalConditions.hasHeartDisease,
                                    Diabetes: surveyInput.medicalConditions.hasDiabetes,
                                    Stroke: surveyInput.medicalConditions.hasHadStroke,
                                    Depression: surveyInput.medicalConditions.hasDepression,
                                    SleepApnea: surveyInput.medicalConditions.hasSleepApnea,
                                    Insomnia: surveyInput.medicalConditions.hasInsomnia,
                                    Narcolepsy: surveyInput.medicalConditions.hasNarcolepsy,
                                    RestlessLeg: surveyInput.medicalConditions.hasRestlessLegSyndrome,
                                    MigraineHeadache: surveyInput.medicalConditions.experiencesMorningHeadache,
                                    PainMedication: surveyInput.medicalConditions.takesPainMedication,
                                    LungDisease: surveyInput.medicalConditions.hasLungDisease,
                                    SleepMedication: surveyInput.medicalConditions.takesSleepingMedication,
                                    SupplementalOxygen: surveyInput.medicalConditions.utilizesSupplementalNasalOxygen,
                                    SittingReading: surveyInput.epworth.sittingReading,
                                    WatchingTV: surveyInput.epworth.watchingTelevision,
                                    PublicPlace: surveyInput.epworth.sittingReadingInPublic,
                                    CarPassenger: surveyInput.epworth.passengerInCar,
                                    AfternoonRest: surveyInput.epworth.restingDuringAfternoon,
                                    Talking: surveyInput.epworth.sittingAndTalking,
                                    Sitting: surveyInput.epworth.sittingAfterLunch,
                                    StoppedCar: surveyInput.epworth.sittingPassengerInCarStoppedInTraffic,
                                    SnoreFrequency: surveyInput.snore.howOftenSnoredInPastMonth,
                                    WakeChokingGasping: surveyInput.snore.wakeUpChokingOrGasping,
                                    ToldChokingGasping: surveyInput.snore.howOftenSomeoneElseTellsChokingOrGasping,
                                    KeepLegsStill: surveyInput.snore.difficultyKeepingLegsStillAtNight,
                                    CreatedBy: null,
                                    ActionUser: null,
                                    RiskTally: null,
                                    PatientStudyGUID: null,
                                    ManufacturerCode: null,
                                    ProbabilityOfAHIFrom0To5: surveyResults.probabilityOfAHIFrom0To5,
                                    ProbabilityOfAHIFrom6To20: surveyResults.probabilityOfAHIFrom6To20,
                                    ProbabilityOfAHIFrom21To40: surveyResults.probabilityOfAHIFrom21To40,
                                    ProbabilityOfAHIOver40: surveyResults.probabilityOfAHIOver40,
                                    ProbabilityOfAHIOver5: surveyResults.probabilityOfAHIOver5,
                                    ProbabilityOfAHIOver20: surveyResults.probabilityOfAHIOver20,
                                    OsaRisk: surveyResults.osaRisk,
                                    OsaSeverity: surveyResults.osaSeverity,
                                    EpworthScore: surveyResults.epworthScore
                                }
            
                                var insertPatientSurvey = () => {
                                    return fetch(this.props.baseAPIURL + "/SleepMed.Service.Main/hst/InsertPatientStudySurveyFromAPI", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(surveyInfo)
                                    })
                                    .then((response) => response.json())
                                    .then((json) => {
                                        if (json) {
                                            // save worked ... 
                                            // make sure "isUsed" flag gets set on Temp URL
                                            var markURLUsed = () => {
                                                return fetch(this.props.baseAPIURL + "/SleepMed.Service.Main/hst/MarkTempURLUsed/" + this.getQueryStringArg("refID"))
                                                .then((response) => {
                                                    // success ... do nothing?
                                                    // hide spinner
                                                    this.setState({ showSpinner: false });
                                                })
                                                .catch((error) => {
                                                    // for now, log to console
                                                    console.log(error);

                                                    // hide spinner
                                                    this.setState({ showSpinner: false });
                                                })
                                            }

                                            markURLUsed();
                                        }
                                        else {
                                            // there was an error saving patient's responses
                                            // verify user hasn't already saved
                                            let refID = this.getQueryStringArg("refID");
                                            var checkForUsedRefID = () => {
                                                return fetch(this.props.baseAPIURL + "/SleepMed.Service.Main/hst/GetURLReferenceInfo", {
                                                    method: "POST",
                                                    headers: {
                                                        "Content-Type": "application/json"
                                                    },
                                                    body: JSON.stringify(refID)
                                                })
                                                .then((response) => response.json())
                                                .then((json) => {
                                                    // display special message, if survey has already been used
                                                    if (json.ErrorReason.toLowerCase() === "used") {
                                                        this.props.onSetCustomErrorMessage("This survey link has already been used. If you previously completed this survey " +
                                                            "on another device, there is no need to resubmit. Thank you!");
                                                    }
                                                    else {
                                                        // generic error (i.e. survey hasn't already been used)
                                                        this.props.onSetCustomErrorMessage("There was a problem saving your responses.");
                                                    }

                                                    this.props.history.push("/error");
                                                })
                                                .catch((error) => {
                                                    // TODO: what do we do on error when calling API?
                                                    // for now, log to console
                                                    console.log(error);

                                                    this.props.onSetCustomErrorMessage("There was a problem saving your responses.");
                                                    this.props.history.push("/error");
                                                });
                                            };
                                            checkForUsedRefID();
                                        }
                                    })
                                    .catch((error) => {
                                        // TODO: what do we do on error when calling API?
                                        // for now, log to console
                                        console.log(error);
                    
                                        // hide spinner
                                        this.setState({ showSpinner: false });
                                    });
                                }
            
                                insertPatientSurvey();

                            })
                            .catch((error) => {
                                console.log(error);

                                this.props.onSetCustomErrorMessage("There was a problem saving your responses.");
                                this.props.history.push("/error");
                            });
                    };

                    getResultsFromAPI();
                }

                break;
        }

        // scroll to the top of the next page, so user doesn't have to when clicking next
        window.scrollTo(0, 0);
    }

    // keeps page from moving forward and displays error message
    showValidationError(nextPage, errorMsg) {
        this.setState({ page: nextPage - 1 });
        this.setState({ errorMsg: <div className="errorMessage">{errorMsg}</div>});
    }

    showInfoMessage(infoMessage) {
        this.setState({ errorMsg: <div className="infoMessage">{infoMessage}</div>});
    }

    // hides the validation error, by removing its HTML
    hideValidationError() {
        this.setState({ errorMsg: null});
    }

    // fired when toggle button choices change
    handleChange(value, obj) {
        this.setState({ [obj.currentTarget.name]: value });

        // set default neck size for selected gender
        if (obj.currentTarget.name === "patientGender") {
            if (value === "male")
                this.setState({ patientNeckSize: "16"});
            else
                this.setState({ patientNeckSize: "13"});
        }
    }

    // fired when form control changes
    // note: control must have id property and corresponding state value for this to work
    handleFormControlChange(event) {
        this.setState({ [event.target.id]: event.target.value });

        // warn for unusual height selection
        let iHeightFeet = parseInt(event.target.value);
        if (event.target.id === "patientHeightFeet") {
            if (iHeightFeet < 4 || iHeightFeet > 6)
                this.showInfoMessage("*You've selected an uncommon height. Please verify your selection.");
            else
                this.hideValidationError();
        }

        // warn for unusual weight selection
        if (event.target.id === "patientWeight") {
            let iWeight = parseInt(event.target.value);
            if (iWeight < 70 || iWeight > 500)
                this.showInfoMessage("*You've entered an unccommon weight. Please verify it's correct.");
            else
                this.hideValidationError();
        }

        // warn for unusual neck size
        if (event.target.id === "patientNeckSize") {
            if (event.target.value < 11 || event.target.value > 20)
                this.showInfoMessage("*You've entered an unccommon neck size. Please verify it's correct.");
            else
                this.hideValidationError();
        }
    }

    // gets patient age from a given date string (e.g. '6/12/1980')
    getAge(dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    render() {  
        let page;
        let imgLogo = this.props.brandLogo; // get logo from component props send by App.js
        let backButton = <Button className="BQNext" variant="primary" onClick={ this.btnBackClick }>Back</Button>;
        let nextButton = <Button className="BQNext" variant="primary" onClick={ this.btnNextClick }>{this.state.pageButtonLabel}</Button>;
        let pageNumber = <div className="PageNumberLabel">Page {this.state.page} of 5</div>;
        switch (this.state.page) {
            case -1:
                backButton = <div style={{ width:"100%" }}></div>; // hide back button
                pageNumber = <div className="PageNumberLabel"></div>; // hide page number label

                // load security page component
                page = <SecurityPage ref={this.SecurityPage} phoneDigits={this.state.phoneDigits} />;

                break;
            case 0:
                backButton = <div style={{ width:"100%" }}></div>; // hide back button
                pageNumber = <div className="PageNumberLabel"></div>; // hide page number label
                page = 
                <div className="SecurityColumn">
                    <Form>
                        <Form.Row>
                            <Col>
                                <Form.Row>
                                    <Form.Label>Gender:</Form.Label>
                                </Form.Row>
                                <Form.Row className="SecurityCondition">
                                    <ToggleButtonGroup name="patientGender" type="radio" value={this.state.patientGender} onChange={this.handleChange}>
                                        <ToggleButton className="BQButton" variant="outline-secondary" value={"male"}>Male</ToggleButton>
                                        <ToggleButton className="BQButton" variant="outline-secondary" value={"female"}>Female</ToggleButton>
                                    </ToggleButtonGroup>
                                </Form.Row>
                            </Col>
                            <Col>
                                <Form.Row>
                                    <Form.Label>Weight:</Form.Label>
                                </Form.Row>
                                <Form.Row className="SecurityCondition">                                    
                                    <FormControl id="patientWeight" className="PhoneDigits" maxLength="4" value={this.state.patientWeight}
                                        onChange={this.handleFormControlChange}></FormControl>&nbsp;lbs.
                                </Form.Row>
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <Form.Row>
                                    <Form.Label>Height:</Form.Label>
                                </Form.Row>
                                <Form.Row className="SecurityCondition">
                                    <FormControl id="patientHeightFeet" as="select" className="BirthDay" onChange={this.handleFormControlChange} 
                                       value={this.state.patientHeightFeet}>
                                        <option disabled value={-1}></option>
                                        <option>2</option>
                                        <option>3</option>
                                        <option>4</option>
                                        <option>5</option>
                                        <option>6</option>
                                        <option>7</option>
                                        <option>8</option>
                                    </FormControl>
                                    &nbsp;feet&nbsp;
                                    <FormControl id="patientHeightInches" as="select" className="BirthDay" onChange={this.handleFormControlChange}
                                        value={this.state.patientHeightInches}>
                                        <option>0</option>
                                        <option>1</option>
                                        <option>2</option>
                                        <option>3</option>
                                        <option>4</option>
                                        <option>5</option>
                                        <option>6</option>
                                        <option>7</option>
                                        <option>8</option>
                                        <option>9</option>
                                        <option>10</option>
                                        <option>11</option>
                                    </FormControl>
                                    &nbsp;inches
                                </Form.Row>
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <Form.Group controlId="formBasicRange">
                                    <Form.Label>Neck Size:</Form.Label>
                                    <div style={{display:"flex"}}>
                                        <div className="NeckSizeText">{this.state.patientNeckSize}&nbsp;inches</div>
                                        <Form.Control id="patientNeckSize" type="range" min="10" max="26" step="0.5" onChange={this.handleFormControlChange}
                                            value={this.state.patientNeckSize} style={{marginBottom:"3px"}} />
                                    </div>                                 
                                </Form.Group>
                            </Col>
                        </Form.Row>
                    </Form>
                </div>
                ;
                break;
            case 1:               
                page = 
                    <div className="BQMainColumn">
                        <SurveyCondition name="hasHighBloodPressure" conditionText="High Blood Pressure" value={this.state.hasHighBloodPressure}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="hasHeartDisease" conditionText="Heart Disease" value={this.state.hasHeartDisease}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="hasDiabetes" conditionText="Diabetes" value={this.state.hasDiabetes}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="hasHadStroke" conditionText="Stroke" value={this.state.hasHadStroke}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="hasDepression" conditionText="Depression" value={this.state.hasDepression}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="hasSleepApnea" conditionText="Sleep Apnea" value={this.state.hasSleepApnea}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="hasLungDisease" conditionText="Lung Disease" value={this.state.hasLungDisease}
                            onChangeCallback={this.handleChange} />
                    </div>
                ;
                break;
            case 2:
                page =
                    <div className="BQMainColumn">                    
                        <SurveyCondition name="utilizesSupplementalNasalOxygen" conditionText="Nasal Oxygen Use" value={this.state.utilizesSupplementalNasalOxygen}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="hasInsomnia" conditionText="Insomnia" value={this.state.hasInsomnia}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="hasRestlessLegSyndrome" conditionText="Restless Leg Syndrome" value={this.state.hasRestlessLegSyndrome}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="hasNarcolepsy" conditionText="Narcolepsy" value={this.state.hasNarcolepsy}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="experiencesMorningHeadache" conditionText="Morning Headaches" value={this.state.experiencesMorningHeadache}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="takesSleepingMedication" conditionText="Sleeping Medication" value={this.state.takesSleepingMedication}
                            onChangeCallback={this.handleChange} />
                        <SurveyCondition name="takesPainMedication" conditionText="Pain Medication (e.g. vicodin, oxycontin)" value={this.state.takesPainMedication}
                            onChangeCallback={this.handleChange} />
                    </div> 
                ;
                break;
            case 3:
                page = 
                    <div>                    
                        <SurveyEpworthItem name="sittingReading" conditionText="Sitting and reading" value={this.state.sittingReading}
                            onChangeCallback={this.handleChange} />
                        <SurveyEpworthItem name="watchingTelevision" conditionText="Watching TV" value={this.state.watchingTelevision}
                            onChangeCallback={this.handleChange} />
                        <SurveyEpworthItem name="sittingReadingInPublic" conditionText="Sitting, inactive, in a public place (theater, meeting, etc.)"
                            value={this.state.sittingReadingInPublic} onChangeCallback={this.handleChange} />
                        <SurveyEpworthItem name="passengerInCar" conditionText="As a passenger in a car for an hour without a break"
                            value={this.state.passengerInCar} onChangeCallback={this.handleChange} />
                    </div>
                ;
                break;
            case 4:
                page = 
                    <div>                    
                        <SurveyEpworthItem name="restingDuringAfternoon" conditionText="Lying down to rest in the afternoon when circumstances permit"
                            value={this.state.restingDuringAfternoon} onChangeCallback={this.handleChange} />
                        <SurveyEpworthItem name="sittingAndTalking" conditionText="Sitting and talking to someone"
                            value={this.state.sittingAndTalking} onChangeCallback={this.handleChange} />
                        <SurveyEpworthItem name="sittingAfterLunch" conditionText="Sitting quietly after lunch without alcohol"
                            value={this.state.sittingAfterLunch} onChangeCallback={this.handleChange} />
                        <SurveyEpworthItem name="sittingPassengerInCarStoppedInTraffic" conditionText="In a car, while stopped for a few minutes in traffic"
                            value={this.state.sittingPassengerInCarStoppedInTraffic} onChangeCallback={this.handleChange} />
                    </div>
                ;
                break;
            case 5:
                page =
                    <div>
                        <div className="BSSKey">
                            <span>Rarely: 0-1 times/week</span>
                            <span>Sometimes: 1-2 times/week</span>
                            <span>Frequently: 3-4 times/week</span>
                            <span>Almost Always: 5-7 times/week</span>
                        </div>
                        <hr className="BQLine" />
                        <SurveyFrequencyItem name="howOftenSnoredInPastMonth"
                            conditionText="On average in the past month, how often have you snored or been told that you snore?"
                            value={this.state.howOftenSnoredInPastMonth} onChangeCallback={this.handleChange} />
                        <SurveyFrequencyItem name="wakeUpChokingOrGasping"
                            conditionText="Do you wake up choking or gasping?"
                            value={this.state.wakeUpChokingOrGasping} onChangeCallback={this.handleChange} />
                        <SurveyFrequencyItem name="howOftenSomeoneElseTellsChokingOrGasping"
                            conditionText="Have you been told that you stop breathing in your sleep or wake up choking or gasping?"
                            value={this.state.howOftenSomeoneElseTellsChokingOrGasping} onChangeCallback={this.handleChange} />
                        <SurveyFrequencyItem name="difficultyKeepingLegsStillAtNight"
                            conditionText="Do you have problems keeping your legs still at night or to move them to feel comfortable?"
                            value={this.state.difficultyKeepingLegsStillAtNight} onChangeCallback={this.handleChange} />
                    </div>
                ;
                break;
            default:
                backButton = <div style={{ width:"100%" }}></div>; // hide back button
                nextButton = <div style={{ width:"100%" }}></div>; // hide next button
                pageNumber = <div className="PageNumberLabel"></div>; // hide page number label

                page = 
                <div className="ResultsMain">
                    <Alert className="Results" variant="primary">
                        <div className="BSSConditionMain">
                            <div className="ResultText">Thank you for completing the survey!</div>
                        </div>
                    </Alert>
                </div>
            ;
                break;
        }

        return (
            <div className="BQMainColumn">
                <div style={{display:"flex", alignItems:"center"}}>
                    <div className="BQMainQuestion">{this.state.pageQuestion}</div>
                    {imgLogo}                   
                </div>
                <hr className="BQLine" />
                {page}
                {this.state.errorMsg} 
                <hr className="BQLine" />                              
                <div className="BQFooter">
                    {backButton}
                    {nextButton}
                </div>
                {pageNumber}
                <SpinnerPage show={this.state.showSpinner} />
            </div>
        );
    }
}
export default withRouter(Questionnaire);